import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUnbilledOrdersReport extends Layout {
    checkboxAvailable: Checkbox;
    checkboxDelivered: Checkbox;
    checkboxInProgress: Checkbox;
    checkboxPageBreak: Checkbox;
    checkboxVoid: Checkbox;
    excludabletextboxCarrier: ExcludableTextbox;
    excludabletextboxCust: ExcludableTextbox;
    excludabletextboxD: ExcludableTextbox;
    labelOrderStatus: Label;
    panelOrderStatus: Panel;
    sourceUnbilledOrders: DataSource;
    switchCustomerInfo: Switch;
    switchOnHold: Switch;
    switchSortBy: Switch;
    switchSortWithin: Switch;
    switchZeroDollarOrders: Switch;
    textboxCurrency: Textbox;
    textboxDate: Textbox;
    textboxGroupBy: Textbox;
    textboxReportBy: Textbox;
    textboxTransferStatus: Textbox;
}
